import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { downloadDocType } from "@lib/util/link-redirection-ops";
import { MuscleButton } from "@modules/shared/components/buttons";
import MuscleCheckbox from "@modules/shared/components/checkbox";
import MuscleCountryInput from "@modules/shared/components/country-input";
import EmailInput from "@modules/shared/components/email-input";
import MuscleFormTextInput from "@modules/shared/components/form-text-input";
import PageContainer from "@modules/layout/components/shared/container";
import TextWithLinks from "@modules/shared/components/text-with-links";
import { useTranslations } from "next-intl";
import React, { useEffect, useState } from "react";
import { DocumentType } from "types/document-type";
import { concatAllString, isAlphanumericString } from "@lib/util/string-ops";
import { Divider } from "@mui/material";
import APP_CONFIGURATION from "@lib/app.config";
import Icons from "@modules/icons";
const DefaultForm = _ref => {
  let {
    info,
    setInfo,
    setIsValid,
    registerType,
    customerId
  } = _ref;
  const t = useTranslations("Shared.Auth");
  const tInputs = useTranslations("Shared.TextInput");

  // Form validation states
  const {
    0: documentIsValid,
    1: setDocumentIsValid
  } = useState(true);
  const {
    0: documentIsValidError,
    1: setDocumentIsValidError
  } = useState();
  useEffect(() => {
    const {
      documentNumber
    } = info;
    if (!isAlphanumericString(documentNumber)) {
      setDocumentIsValid(false);
      setDocumentIsValidError(tInputs("FIELD_MUST_BE_ALPHANUMERIC"));
    } else if (documentNumber.length < 8) {
      setDocumentIsValid(false);
      setDocumentIsValidError(tInputs("FIELD_MUST_BE_AT_LEAST_8_CHARACTERS"));
    } else {
      setDocumentIsValid(true);
      setDocumentIsValidError(undefined);
    }
  }, [info]);
  useEffect(() => {
    const valid = info.name !== "" && info.lastName !== "" && info.country !== "" && info.email !== "" && info.confirmEmail !== "" && info.email === info.confirmEmail && info.documentNumber !== "" && info.acceptTerms;
    setIsValid(valid && documentIsValid);
  }, [documentIsValid, info, registerType, setIsValid]);
  return __jsx(React.Fragment, null, __jsx(MuscleFormTextInput, {
    label: t("NAME"),
    required: true,
    onChangeValue: value => setInfo(_objectSpread(_objectSpread({}, info), {}, {
      name: value
    })),
    value: info.name,
    maxLength: 50,
    fullLength: true
  }), __jsx(MuscleFormTextInput, {
    label: t("LAST_NAME"),
    required: true,
    onChangeValue: value => setInfo(_objectSpread(_objectSpread({}, info), {}, {
      lastName: value
    })),
    value: info.lastName,
    maxLength: 50,
    fullLength: true
  }), __jsx(MuscleFormTextInput, {
    label: t("SECOND_LAST_NAME"),
    onChangeValue: value => setInfo(_objectSpread(_objectSpread({}, info), {}, {
      secondLastName: value
    })),
    maxLength: 50,
    value: info.secondLastName,
    fullLength: true
  }), __jsx(MuscleCountryInput, {
    label: t("COUNTRY"),
    required: true,
    onChange: value => setInfo(_objectSpread(_objectSpread({}, info), {}, {
      country: value
    })),
    value: info.country
  }), __jsx(MuscleFormTextInput, {
    label: t("DOCUMENT_NUMBER"),
    onChangeValue: value => setInfo(_objectSpread(_objectSpread({}, info), {}, {
      documentNumber: value
    })),
    value: info.documentNumber,
    mode: "alphanumeric",
    maxLength: 15,
    invalidValueMessage: documentIsValidError,
    valueIsInvalid: !documentIsValid,
    required: true,
    fullLength: true
  }), __jsx(React.Fragment, null, __jsx("div", {
    className: "flex flex-col md:flex-row gap-8"
  }, __jsx(EmailInput, {
    label: t("EMAIL"),
    required: true,
    onChangeValue: value => setInfo(_objectSpread(_objectSpread({}, info), {}, {
      email: value
    })),
    value: info.email,
    fullLength: true,
    containerClassName: "flex-1"
  }), __jsx(EmailInput, {
    label: t("CONFIRM_EMAIL"),
    value: info.confirmEmail,
    required: true,
    onChangeValue: value => setInfo(_objectSpread(_objectSpread({}, info), {}, {
      confirmEmail: value
    })),
    fullLength: true,
    containerClassName: "flex-1"
  }))), __jsx("br", null), __jsx("div", {
    className: "flex flex-row gap-1 items-center"
  }, __jsx(MuscleCheckbox, {
    value: info.acceptTerms,
    onChange: () => setInfo(_objectSpread(_objectSpread({}, info), {}, {
      acceptTerms: !info.acceptTerms
    }))
  }), __jsx(TextWithLinks, {
    text: t("I_ACCEPT_THE_TERMS_AND_CONDITIONS"),
    linksActions: [() => downloadDocType(DocumentType.TERMS_AND_CONDITIONS)]
  })));
};
const MuscleBenefitRegistrationScreen = _ref2 => {
  let {
    onSubmit,
    isSubmitting,
    onClickBack,
    title,
    description,
    buttonText,
    customerId
  } = _ref2;
  const t = useTranslations("Shared.Auth");
  const tGeneral = useTranslations("Shared");
  const tInputs = useTranslations("Shared.TextInput");
  const allowSocialMediaAuth = (process.env.NEXT_PUBLIC_SOCIAL_MEDIA_AUTH || "false") === "true";
  const {
    0: loading,
    1: setLoading
  } = useState(false);
  const {
    0: providerAuth,
    1: setProviderAuth
  } = useState(null);
  const {
    0: info,
    1: setInfo
  } = useState({
    name: "",
    lastName: "",
    secondLastName: "",
    country: "",
    email: "",
    confirmEmail: "",
    password: "",
    passwordConfirmation: "",
    acceptTerms: false,
    documentNumber: ""
  });
  const {
    0: isValid,
    1: setIsValid
  } = useState(false);
  const finishRegistration = async () => {
    try {
      setLoading(true);
      await onSubmit({
        first_name: info.name,
        last_name: concatAllString(" ", info.lastName, info.secondLastName),
        country: info.country,
        identification_number: info.documentNumber,
        email: info.email,
        userId: customerId
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };
  return __jsx(PageContainer, null, __jsx("div", {
    className: "max-w-[470px] w-full self-center flex flex-col gap-3 pb-[120px]"
  }, __jsx("div", {
    className: "flex flex-col gap-4 text-center text-black "
  }, __jsx("div", {
    className: "flex flex-row items-center justify-center gap-2"
  }, __jsx(Icons.circleCheck, {
    size: 20,
    color: APP_CONFIGURATION.colors.success_main
  }), __jsx("div", {
    className: "text-2xl font-bold text-primary-main"
  }, title)), __jsx("div", {
    className: "text-base font-thin "
  }, description), allowSocialMediaAuth && !providerAuth && __jsx(React.Fragment, null, __jsx(Divider, null, __jsx("span", {
    className: "text-neutral-400"
  }, tGeneral("OR"))))), __jsx(DefaultForm, {
    info: info,
    setInfo: setInfo,
    setIsValid: setIsValid,
    registerType: "provider",
    customerId: customerId
  }), __jsx("br", null), __jsx("div", {
    className: "flex w-full items-center justify-center"
  }, __jsx(MuscleButton, {
    text: buttonText,
    disabled: !isValid || loading,
    onClick: () => finishRegistration(),
    isLoading: isSubmitting || loading
  }))));
};
export default MuscleBenefitRegistrationScreen;